import { render, staticRenderFns } from "./LocationSlot.vue?vue&type=template&id=c66e10e0&scoped=true&"
import script from "./LocationSlot.vue?vue&type=script&lang=js&"
export * from "./LocationSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66e10e0",
  null
  
)

export default component.exports